import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-1"><path fillRule="evenodd" clipRule="evenodd" d="M2 4.75C2 4.33579 2.33579 4 2.75 4H21.25C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75ZM3.5 5.5V7H20.5V5.5H3.5ZM20.5 8.5H3.5V10H8.75C9.16421 10 9.5 10.3358 9.5 10.75V12.5H14.5V10.75C14.5 10.3358 14.8358 10 15.25 10H20.5V8.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconWallet1;
